import React from 'react';
import { RoutePermittedRole } from '../../constants/AppEnums';

const Inicio = React.lazy(() => import('../../../modules/blueSoft/Inicio'));
const Compras = React.lazy(() => import('../../../modules/blueSoft/Compras'));
const Ventas = React.lazy(() => import('../../../modules/blueSoft/Ventas'));
const EdicionVenta = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionVenta'),
);
const Recibos = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Recibos'),
);
const EdicionRecibo = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionRecibo'),
);
const PedidosDeVenta = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/PedidosDeVenta'),
);
const EdicionPedidoDeVenta = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionPedidoDeVenta'),
);
const CtaCteClientes = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/CtaCteClientes'),
);
const CtaCteClientesDetalle = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/CtaCteClientesDetalle'),
);
const Clientes = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Clientes'),
);
const EdicionCliente = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/EdicionCliente'),
);
const Productos = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/Productos'),
);
const ProductoVista = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/ProductoVista'),
);
const AnalisisDeVentas = React.lazy(
  () => import('../../../modules/blueSoft/Ventas/AnalisisDeVentas'),
);
const EdicionCompra = React.lazy(
  () => import('../../../modules/blueSoft/Compras/EdicionCompra'),
);
const CtaCteProveedores = React.lazy(
  () => import('../../../modules/blueSoft/Compras/CtaCteProveedores'),
);
const CtaCteProveedoresDetalle = React.lazy(
  () => import('../../../modules/blueSoft/Compras/CtaCteProveedoresDetalle'),
);
const Pagos = React.lazy(
  () => import('../../../modules/blueSoft/Compras/Pagos'),
);
const EdicionPago = React.lazy(
  () => import('../../../modules/blueSoft/Compras/EdicionPago'),
);
const Proveedores = React.lazy(
  () => import('../../../modules/blueSoft/Compras/Proveedores'),
);
const EdicionProveedor = React.lazy(
  () => import('../../../modules/blueSoft/Compras/EdicionProveedor'),
);
const AnalisisDeCompras = React.lazy(
  () => import('../../../modules/blueSoft/Compras/AnalisisDeCompras'),
);
const Documento = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoView'),
);
const DocumentoPrint = React.lazy(
  () => import('../../../modules/blueSoft/Components/DocumentoPrintView'),
);
const MovimientosDeCaja = React.lazy(
  () => import('../../../modules/blueSoft/Cajas/MovimientosDeCaja'),
);
const EdicionMovimientoDeCaja = React.lazy(
  () => import('../../../modules/blueSoft/Cajas/EdicionMovimientoDeCaja'),
);
const OrdenesDeProceso = React.lazy(
  () => import('../../../modules/blueSoft/Produccion'),
);
const OrdenesDeProduccion = React.lazy(
  () => import('../../../modules/blueSoft/Produccion/OrdenesDeProduccion'),
);
const OrdenDeProduccionVista = React.lazy(
  () => import('../../../modules/blueSoft/Produccion/OrdenDeProduccionVista'),
);
const IngresosDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/IngresosDeMercaderia'),
);
const SalidasDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/SalidasDeMercaderia'),
);
const EdicionMovimientoDeMercaderia = React.lazy(
  () => import('../../../modules/blueSoft/Stock/EdicionMovimientoDeMercaderia'),
);
const Stock = React.lazy(() => import('../../../modules/blueSoft/Stock'));

const RotacionDeStock = React.lazy(
  () => import('../../../modules/blueSoft/Stock/RotacionDeStock'),
);

const MateriasPrimas = React.lazy(
  () => import('../../../modules/blueSoft/Compras/MateriasPrimas'),
);
const PlanDeCuentas = React.lazy(
  () => import('../../../modules/blueSoft/Compras/PlanDeCuentas'),
);
const PreguntaIA = React.lazy(
  () => import('../../../modules/blueSoft/IA/PreguntaIA'),
);

export const blueSoftPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/Inicio',
    element: <Inicio />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ia/pregunta',
    element: <PreguntaIA />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/view',
    element: <Documento />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/documento/print',
    element: <DocumentoPrint />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/documentos',
    element: <Compras />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/nueva',
    element: <EdicionCompra />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/edicion',
    element: <EdicionCompra />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/ctacte/detalle/documento',
    element: <Documento />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/ctacte/detalle',
    element: <CtaCteProveedoresDetalle />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/ctacte',
    element: <CtaCteProveedores />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/pagos',
    element: <Pagos />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/pagos/nuevo',
    element: <EdicionPago />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/pagos/edicion',
    element: <EdicionPago />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/proveedores/nuevo',
    element: <EdicionProveedor />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/proveedores/edicion',
    element: <EdicionProveedor />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/proveedores',
    element: <Proveedores />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/analisis',
    element: <AnalisisDeCompras />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/materiasprimas',
    element: <MateriasPrimas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/compras/plandecuentas',
    element: <PlanDeCuentas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/ctacte/detalle/documento',
    element: <Documento />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/ctacte/detalle',
    element: <CtaCteClientesDetalle />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/ctacte',
    element: <CtaCteClientes />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes/nuevo',
    element: <EdicionCliente />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes/edicion',
    element: <EdicionCliente />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/clientes',
    element: <Clientes />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/producto/vista',
    element: <ProductoVista />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/productos',
    element: <Productos />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/documentos',
    element: <Ventas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/nueva',
    element: <EdicionVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/edicion',
    element: <EdicionVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/recibos',
    element: <Recibos />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/recibos/nuevo',
    element: <EdicionRecibo />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/recibos/edicion',
    element: <EdicionRecibo />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos',
    element: <PedidosDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos/nuevo',
    element: <EdicionPedidoDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/pedidos/edicion',
    element: <EdicionPedidoDeVenta />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/ventas/analisis',
    element: <AnalisisDeVentas />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/cajas/movimientos/nuevo',
    element: <EdicionMovimientoDeCaja />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/cajas/movimientos/edicion',
    element: <EdicionMovimientoDeCaja />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/cajas/movimientos',
    element: <MovimientosDeCaja />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos',
    element: <IngresosDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas',
    element: <SalidasDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos/nuevo',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/ingresos/edicion',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas/nueva',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/salidas/edicion',
    element: <EdicionMovimientoDeMercaderia />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/consulta',
    element: <Stock />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/stock/rotacion',
    element: <RotacionDeStock />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/produccion/ordenesDeProduccion',
    element: <OrdenesDeProduccion />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/produccion/ordenesDeProduccion/:sucursal/:numero',
    element: <OrdenDeProduccionVista />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/blueSoft/produccion/ordenesDeProceso',
    element: <OrdenesDeProceso />,
  },
];
